import { render, staticRenderFns } from "./GroupProfileDetails.vue?vue&type=template&id=680b7e52&scoped=true&"
import script from "./GroupProfileDetails.vue?vue&type=script&lang=js&"
export * from "./GroupProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupProfileDetails.vue?vue&type=style&index=0&id=680b7e52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b7e52",
  null
  
)

export default component.exports